"use client"

import styled from "@emotion/styled"
import Image from "next/image"
import { NewText } from "ui"

const StyledLayout = styled.div`
  position: relative;
  padding-top: 40px;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
  margin-left: auto;

  ${(props) => props.theme.breakpoints.up("sm")} {
    margin-left: unset;
    padding: 0;
    margin-bottom: 22px;
    padding: 0 26px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-bottom: 33px;
    padding: 0 39px;
  }
`

const PartnershipLogo = styled.div`
  width: 68px;
  height: 54px;
  position: relative;
  margin-bottom: 25px;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 88px;
    height: 70px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-bottom: 38px;
    width: 132px;
    height: 104px;
  }
`

const PartnershipText = styled(NewText)`
  margin: 0;
  position: absolute;
  top: -15px;
`

const BrandLogo = styled.div`
  width: 74px;
  height: 17px;

  position: relative;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 88px;
    height: 20px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-bottom: 33px;
    width: 132px;
    height: 30px;
  }
`

export default function PartnershipSection() {
  return (
    <StyledLayout>
      <PartnershipLogo>
        <Image src="/images/partnership-logo.jpg" alt="" fill priority />
      </PartnershipLogo>

      <BrandLogo>
        <PartnershipText
          component="p"
          mobileFontSize={15}
          smallDesktopFontSize={17}
          desktopFontSize={26}
          desktopLineHeight={"106.6%"}
          desktopFontWeight={200}
          color="white"
        >
          בשיתוף
        </PartnershipText>
        <Image src="/images/brand-logo.jpg" alt="Brand logo" fill priority />
      </BrandLogo>
    </StyledLayout>
  )
}
